import { toggleCheckboxSubmit } from '@pc/components/ToggleCheckboxSubmit'

document.addEventListener('DOMContentLoaded', () => {
  // checkbox に check があるか否かで、submit button の活性／非活性を切り替える
  toggleCheckboxSubmit()
})
